import { AfterViewInit, ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExtendedFileMetadata } from '@lib/models/extended-file-metadata';
import { UpdateDocumentMetadatasCommandInput } from '@lib/models/generated/graphql';
import { DocumentsService } from '@lib/services/documents.service';
import { OuiSnackbarService } from 'omnium-ui/snackbar';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { emptyOrWhitespaceValidator } from '@lib/validators/emptyOrWhitespace.validator';

@Component({
  selector: 'app-update-document-dialog',
  imports: [SHARED_IMPORTS],
  templateUrl: './update-document-dialog.component.html',
  styleUrl: './update-document-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateDocumentDialogComponent implements AfterViewInit {
  public documentService = inject(DocumentsService);
  public snackbarService = inject(OuiSnackbarService);
  public dialogRef = inject(MatDialogRef<UpdateDocumentDialogComponent>);
  public data = inject<{
    document: ExtendedFileMetadata;
    updateType: 'name';
  }>(MAT_DIALOG_DATA);
  public fileNameControl = new FormControl<string>('', [Validators.required, emptyOrWhitespaceValidator]);
  public typeControl = new FormControl<string>('', Validators.required);
  public saving = signal<boolean>(false);

  ngAfterViewInit(): void {
    this.typeControl.patchValue(this.data.document.typeDocumentCode as string);

    const nameWithoutExtension =
      this.data.document.fileName?.substring(0, this.data.document.fileName.lastIndexOf('.')) || this.data.document.fileName;
    this.fileNameControl.patchValue(nameWithoutExtension as string);
  }

  public updateDocument(): void {
    this.saving.set(true);
    const input = {} as UpdateDocumentMetadatasCommandInput;
    input.nomDeFichier = `${this.fileNameControl.value}.${this.data.document.extension}`;
    this.documentService
      .updateFileMetadata(this.data.document.baseFileId, input)
      .then(res => {
        if (res) {
          this.snackbarService.open('Le document a été modifié', 'success');
        } else {
          this.snackbarService.open('Erreur lors de la modification du document', 'error');
        }
      })
      .finally(() => {
        this.dialogRef.close(true);
        this.saving.set(false);
      });
  }
}
